import { Box, Button as MuiButton, Grid } from '@material-ui/core';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { IButton } from 'src/common/interfaces/IButton';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './search-transactions-bottom-control-styles';

interface ISearchTransactionsBottomControlProps {
  submitButton: IButton;
}
const SearchTransactionsBottomControl = ({
  submitButton,
}: ISearchTransactionsBottomControlProps): JSX.Element => {
  const startPage: number = 1;
  const lastPage: number = 1;

  const classes = styles();

  return (
    <Grid container justifyContent='flex-end'>
      <Grid item xs={9}>
        <Grid container justifyContent='center' className='fullHeight hidden'>
          <Grid item>
            <VerticalCenter>
              <Grid item>
                <MuiButton
                  disabled={startPage === 0 || startPage === 1}
                  className={classes.arrowButtons}
                >
                  <ArrowUpward />
                </MuiButton>
              </Grid>
            </VerticalCenter>
          </Grid>
          <Grid item>
            <VerticalCenter>
              <Box className={classes.navigationLabel}>
                {startPage} OF {lastPage}
              </Box>
            </VerticalCenter>
          </Grid>
          <Grid item>
            <VerticalCenter>
              <Grid item>
                <MuiButton disabled={startPage === lastPage} className={classes.arrowButtons}>
                  <ArrowDownward />
                </MuiButton>
              </Grid>
            </VerticalCenter>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3}>
        <VerticalCenter justifyContent='flex-end'>
          <BaseButton
            data-testid='recall-trans-add-item-btn'
            className={classes.addButton}
            onClick={() => submitButton.onClick()}
            disabled={submitButton.disabled}
          >
            {submitButton.label}
          </BaseButton>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

export default SearchTransactionsBottomControl;
